import React, { useEffect, useState } from "react";

const scrollToForm = () => {
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0F2240]/85 border-b border-[#B89968]/15"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center group"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_newman-justice-fund/artifacts/a662viyt_Newman%20Injury%20Law.png"
            alt="Newman Injury Law"
            fetchpriority="high"
            decoding="async"
            className="h-12 md:h-14 w-auto transition-opacity group-hover:opacity-90"
            style={{
              filter:
                "brightness(0) invert(1) drop-shadow(0 1px 0 rgba(0,0,0,0.2))",
            }}
          />
        </a>

        <button
          data-testid="header-cta-free-consultation"
          onClick={scrollToForm}
          className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 border border-[#B89968] text-[#B89968] hover:bg-[#B89968] hover:text-[#0F2240] transition-colors duration-300 text-sm uppercase tracking-[0.18em] font-medium"
        >
          Free Consultation
        </button>
      </div>
    </header>
  );
}
